import { selector } from 'recoil'
import { hashContentPath } from 'common/src/ContentPath'
import { ContentTree } from 'common/src/ContentTree/types'
import { contentTreeStateAtom } from '@/atoms/contentTree'
import { getContentTreeChildForContentPath } from '@/utils/getContentTreeChildForContentPath'

export const hashedContentPathsInCanonicalOrderSelector = selector<string[]>({
    key: 'hashedContentPathsInCanonicalOrderSelector',
    get: ({ get }) =>
        get(contentTreeStateAtom).flattenedContentTree.map(hashContentPath),
})

// Every tree node's OWN name (not breadcrumb), keyed by the hashed id-path
// prefix that reaches it — for hierarchical groupings that label each tier
export const nodeNameByHashedPrefixSelector = selector<Map<string, string>>({
    key: 'nodeNameByHashedPrefixSelector',
    get: ({ get }) => {
        const { contentTree } = get(contentTreeStateAtom)
        const names = new Map<string, string>()
        const walk = (node: ContentTree, prefix: string[]): void => {
            node.children.forEach((child) => {
                const path = [...prefix, child.id]
                names.set(hashContentPath(path), child.name)
                walk(child, path)
            })
        }
        walk(contentTree, [])
        return names
    },
})

export const sectionTitleByHashedContentPathSelector = selector<
    Map<string, string>
>({
    key: 'sectionTitleByHashedContentPathSelector',
    get: ({ get }) => {
        const contentTreeState = get(contentTreeStateAtom)
        return new Map(
            contentTreeState.flattenedContentTree.map((contentPath) => {
                const titles = contentPath.map((fallbackTitle, index) => {
                    const node = getContentTreeChildForContentPath(
                        contentTreeState.contentTree,
                        contentPath.slice(0, index + 1)
                    )
                    return node?.name ?? fallbackTitle
                })
                return [hashContentPath(contentPath), titles.join(' › ')]
            })
        )
    },
})
